module.exports = __webpack_public_path__ + "img/Cruella poster.f9fc80cd.png";